import React from "react";
import DescriptionIcon from '@mui/icons-material/Description';
import { Grid, Typography, Alert, ListItemText, List, ListItem, ListItemIcon } from "@mui/material";
import { useTranslation } from "react-i18next";

function Block1({type, licenceTypeId = null, moduleId = null}) {
    const { t } = useTranslation();
    return (
        <>
            <style>
                {`
                    .MuiAlert-icon {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                    }
                `}
            </style>
            <Grid item sm={8} sx={{ textAlign: "center", backgroundColor: "#004EAA", py: 1, color: "#fff" }}>
                <Typography variant="h1">
                    {type === 7 ? "Foráneos" 
                    : type === 6 ? "Extranjeros" 
                    : " Primera vez"}
                </Typography><br></br>
                <Typography sx={{ mb: 1 }} variant="h3" style={{ fontWeight: 400, color: "#fff" }}>
                    {
                        (() => {
                            switch (type) {
                                case 1:
                                    return t("HOME.FIRST_TIME_DESCRIPTION");
                                case 6:
                                    return t("HOME.FIRST_TIME_DESCRIPTION2");
                                case 7:
                                    return t("HOME.FIRST_TIME_DESCRIPTION2");
                                default:
                                    return '';
                            }
                        })()
                    }
                </Typography>
            </Grid>

            <Grid item sm={12} sx={{ mb: 1, mt: 2 }}>
                <Alert severity="info" variant="outlined">
                <Typography variant="h4" style={{ fontWeight: 500 }}>
                        <b style={{ fontSize: '30px'  }}>· {t("BLOCK_1.ON_TIME_SHORT_DESCRIPTION")}</b>
                    </Typography>
                    {
                       type === 1 ? 
                            <Typography variant="h4" style={{ fontWeight: 500 }}>
                                · {t("BLOCK_1.MANDATORY_TEST")}
                            </Typography>
                        : null
                    }
                    <Typography variant="h4" style={{ fontWeight: 500 }}>
                        · {t("BLOCK_1.BLOOD_TYPE")}
                    </Typography>
                </Alert>
            </Grid>

            <Grid item sm={12} sx={{ mb: 0 }}>
                <Typography variant="h3" style={{ fontWeight: 500 }}>
                     {t("BLOCK_1.REQUIREMENTS_DESCRIPTION")}
                </Typography>

                <List sx={{ width: '100%' }}>
                    {type != 6 ? 
                        <ListItem alignItems="flex-start">
                            <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                                <DescriptionIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <React.Fragment>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="h4"
                                            color="text.primary"
                                        >
                                             {t("BLOCK_1.BIRTH_CERTIFICATE")}
                                        </Typography>
                                    </React.Fragment>}
                            />
                        </ListItem>
                    : null}
                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        Comprobante de pago de validación de aptitudes teóricas y prácticas de conducción de vehículos
                                    </Typography>
                                </React.Fragment>}
                        />
                    </ListItem>

                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        CURP
                                    </Typography>
                                </React.Fragment>}
                        />
                    </ListItem>

                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        Identificación oficial (INE, pasaporte mexicano, cartilla militar, cédula profesional), en el caso de menores de edad:
                                        credencial escolar vigente, pasaporte mexicano vigente, y tendrá que presentarse con papá, mamá o tutor legal y la identificación del mismo.
                                    </Typography>
                                </React.Fragment>}
                        />
                    </ListItem>

                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        Comprobante de domicilio
                                    </Typography>
                                </React.Fragment>}
                            secondary={
                                <React.Fragment>
                                    {<Typography>
                                        Comprobante de domicilio oficial a nombre del interesado, fecha reciente (agua, luz, gas natural, predial o teléfono activo). En caso de no
                                        estar a su nombre, acompañarlo de algún estado de cuenta bancario o de tiendas departamentales con el mismo domicilio del recibo oficial
                                        y/o el INE actualizado. En caso de los menores de edad presentar comprobante de domicilio a nombre del tutor legal.
                                    </Typography>}
                                </React.Fragment>
                            }
                        />
                    </ListItem>
                    
                    {type == 6 ?
                        <ListItem alignItems="flex-start">
                            <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                                <DescriptionIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <React.Fragment>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="h4"
                                            color="text.primary"
                                        >
                                            Residencia temporal o permanente (FM2 O FM3)
                                        </Typography>
                                    </React.Fragment>}
                                secondary={
                                    <React.Fragment>
                                        {<Typography>
                                            · Permiso temporal: Presentar pasaporte de su país, acreditar domicilio y su licencia se autoriza solo por 1 ó 3 años.
                                            · Permiso permanente: Licencia anterior, permiso permanente, acreditar domicilio y su licencia se le autoriza hasta por 6 años.
                                        </Typography>}
                                    </React.Fragment>
                                }
                            />
                        </ListItem>
                    : null}

                    {type == 6 ?
                        <ListItem alignItems="flex-start">
                            <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                                <DescriptionIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <React.Fragment>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="h4"
                                            color="text.primary"
                                        >
                                            Pasaporte del país de origen
                                        </Typography>
                                    </React.Fragment>}
                            />
                        </ListItem>
                    : null}

                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        En caso de licencia para motociclista presentar (moto y casco) únicamente en Chihuahua capital
                                    </Typography>
                                </React.Fragment>}
                        />
                    </ListItem>

                    {type === 1 && licenceTypeId == 7 && moduleId == 1 ?
                        <ListItem alignItems="flex-start">
                            <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                                <DescriptionIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <React.Fragment>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="h4"
                                            color="text.primary"
                                        >
                                            Favor de presentarse con un vehículo particular para la aplicación de la evaluación práctica
                                        </Typography>
                                    </React.Fragment>}
                            />
                        </ListItem>
                    : null
                    }
                </List>
            </Grid>

            <Grid container rowSpacing={2}>
                <Grid item sm={12}>
                    <Typography sx={{ fontSize: "15px" }}>
                        <span style={{ color: "#9568C6", fontWeight: "bold" }}>Automovilista particular: </span>
                        Autoriza al interesado a conducir vehículos particulares hasta de doce plazas, o de carga particular cuyo peso máximo autorizado no exceda de 3.5 Toneladas.
                    </Typography>
                </Grid>

                <Grid item sm={12}>
                    <Typography sx={{ fontSize: "15px" }}>
                        <span style={{ color: "#9568C6", fontWeight: "bold" }}>Chofer particular: </span>
                        Autoriza al interesado a conducir vehículos particulares destinados al transporte hasta veintidós plazas y un peso máximo de diez toneladas.
                    </Typography>
                </Grid>
                <Grid item sm={12}>
                    <Typography sx={{ fontSize: "15px" }}>
                        <span style={{ color: "#9568C6", fontWeight: "bold" }}>Motociclista: </span>
                        Autoriza al interesado a manejar cualquier tipo de motocicleta.
                    </Typography>
                </Grid>
                <Grid item sm={12}>
                    <Typography sx={{ fontSize: "15px", textAlign: 'center' }}>
                        De acuerdo al artículo 54 de la Ley de Vialidad y Tránsito para el Estado de Chihuahua vigente.
                    </Typography>
                </Grid>
            </Grid>
        </>
    );
}
export default Block1;